import { useEffect } from 'react';

const getScryptByEnv = () => {
  const { origin } = window.location;

  if (origin.includes('portal-trabalhador.vr.com.br')) {
    return './dynatrace/dynatrace-prod.min.js';
  }
  if (origin.includes('voce.caixaprepagos.com.br')) {
    return './dynatrace/dynatrace-jvcef-prod.min.js';
  }
  return './dynatrace/dynatrace-non-prod.min.js';
};

const useDynatraceScript = () => {
  useEffect(() => {
    if (!document.getElementById('vr-dynatrace-script')) {
      const script = document.createElement('script');
      script.src = getScryptByEnv();
      script.id = 'vr-dynatrace-script';

      document.head.appendChild(script);
    }
  }, []);
};

export default useDynatraceScript;
